import { render, staticRenderFns } from "./TranslationBanner.vue?vue&type=template&id=50c8b9ba&"
import script from "./TranslationBanner.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TranslationBanner.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports